import { PTSData } from '@/types';
import { Core, PTS } from '../Core';

class Pts extends Core {
  getPTSData = async () => this.get<PTSData>(PTS());
}

export const pts = new Pts();
